import React from 'react';
import Navigation from '../../ui/navigation/navigation';
import useTranslate from '../../../common/hooks/useTranslate';

// @ts-ignore
import LogoSidebar from '../../../assets/images/logoSidebar.svg';

import './sidebar.scss';

const Sidebar = () => {
  const { t } = useTranslate();

  return (
    <div className='sidebar-wrapper'>
      <span className='sidebar-logo'>{t('LP')}</span>
      <Navigation />
      <div className="company-logo">
        <img src={LogoSidebar} alt='CapInteract' />
      </div>
    </div>
  );
};

export default Sidebar;
